import React, { Suspense, lazy } from 'react';
import { Link } from 'react-router-dom';
import { BarChart3, ChevronRight } from 'lucide-react';

const PollWidget = lazy(() => import('../PollWidget'));
const SportsScoreWidget = lazy(() => import('../SportsScoreWidget'));

function TrendoviPanel({ categories, t }) {
  const gridCols = categories.length <= 3 ? 'grid-cols-1' : 'grid-cols-2';
  return (
    <div className="bg-white dark:bg-navy-light rounded-xl border border-gray-100 dark:border-white/5 p-3.5" data-testid="trendovi-panel">
      <div className="flex items-center gap-1.5 mb-2.5">
        <BarChart3 size={14} className="text-sky-accent" />
        <h3 className="font-display text-[11px] font-bold text-navy dark:text-white tracking-wide uppercase">{t('trending')}</h3>
      </div>
      {categories.length > 0 ? (
        <div className={`grid ${gridCols} gap-1.5`}>
          {categories.slice(0, 8).map((cat, idx) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              data-testid={`top-cat-${cat.slug}`}
              className="group flex items-center gap-2.5 px-3 py-2.5 rounded-lg border transition-all hover:shadow-md hover:-translate-y-0.5"
              style={{ borderColor: cat.color + '25', background: `linear-gradient(135deg, ${cat.color}08, ${cat.color}03)` }}
            >
              <span className="w-6 h-6 rounded-md flex items-center justify-center flex-shrink-0 text-white text-[10px] font-bold shadow-sm" style={{ backgroundColor: cat.color }}>
                {idx + 1}
              </span>
              <div className="min-w-0 flex-1">
                <span className="text-[11px] font-display font-semibold text-navy dark:text-white block truncate leading-tight">{cat.category}</span>
                <span className="text-[9px] text-gray-400 font-display">{cat.article_count} Objava</span>
              </div>
              <ChevronRight size={12} className="text-gray-300 group-hover:text-sky-accent transition-colors flex-shrink-0" />
            </Link>
          ))}
        </div>
      ) : (
        <div className="space-y-1.5">{[1,2,3].map(i => <div key={i} className="h-10 bg-gray-100 dark:bg-white/5 rounded-lg animate-pulse" />)}</div>
      )}
    </div>
  );
}

export default function ThreeColumnPanel({ categories, t }) {
  return (
    <section className="grid grid-cols-1 md:grid-cols-3 gap-3 mb-6" data-testid="three-column-panel">
      <TrendoviPanel categories={categories} t={t} />
      <div className="bg-white dark:bg-navy-light rounded-xl border border-gray-100 dark:border-white/5 p-3.5 overflow-hidden">
        <Suspense fallback={<div className="h-24 animate-pulse bg-gray-100 dark:bg-white/5 rounded-lg" />}>
          <PollWidget />
        </Suspense>
      </div>
      <div className="bg-white dark:bg-navy-light rounded-xl border border-gray-100 dark:border-white/5 p-3.5 overflow-hidden">
        <Suspense fallback={<div className="h-24 animate-pulse bg-gray-100 dark:bg-white/5 rounded-lg" />}>
          <SportsScoreWidget />
        </Suspense>
      </div>
    </section>
  );
}
